import { render, staticRenderFns } from "./dataMangement.vue?vue&type=template&id=c19d1160&scoped=true&"
import script from "./dataMangement.vue?vue&type=script&lang=js&"
export * from "./dataMangement.vue?vue&type=script&lang=js&"
import style0 from "./dataMangement.vue?vue&type=style&index=0&id=c19d1160&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19d1160",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c19d1160', component.options)
    } else {
      api.reload('c19d1160', component.options)
    }
    module.hot.accept("./dataMangement.vue?vue&type=template&id=c19d1160&scoped=true&", function () {
      api.rerender('c19d1160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/dataMangement.vue"
export default component.exports